// @ts-ignore add TS check, handle history code
import { version } from '../package.json';
import '@bluevision/components/index.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__APP_VERSION = version;

// 配置 dva 创建时的参数 , 参见：https://dvajs.com/api/#app-dva-opts，可以捕获 effects 和 subscriptions 中的错误
export const dva = {
  config: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError(err: any) {
      console.error(err);
      // err.preventDefault() // 阻止 error 的继续抛出？目前看是这样，不知是不是 dva 封装了 err 的方法
    },
  },
};
